import { Wrench } from 'lucide-react'
import Box from '@/common/components/Box'
import ResumeItem from '@/common/components/ResumeItem'
import { formatDateTime } from '@/common/utils/formatters'
import { maintenanceForwardingEntryTypeLabel } from '@shared/maintenance/forwardingEntryLabels'
import { equipmentFieldForDisplayLabel } from '../../../constants/equipmentFieldForDisplay.constant'
import { proposalDirectiveEntries } from '../../../constants/proposalDirectiveEntries.constant'
import { ManualEntryProposalShowData } from '../../../types/maintenanceManualEntryProposal.type'
import { ColumnHeader, Section, TextBlock } from './showPrimitives'
import ProposalSolicitations from './ProposalSolicitations'

type Props = {
  proposal: ManualEntryProposalShowData
}

const ProposalProcessColumn = ({ proposal }: Props) => {
  const forwarding = proposal.manual_entry?.forwarding
  const directiveEntryType = forwarding?.directive_entry_type
  const directiveConfig = directiveEntryType ? proposalDirectiveEntries[directiveEntryType] : undefined
  const equipment = forwarding?.workflow?.equipment
  const equipmentModel = equipment?.model?.display_name
  const equipmentFieldLabel =
    (equipment?.field_for_display && equipmentFieldForDisplayLabel[equipment.field_for_display]) || 'Identificador'
  const equipmentModelLabel = equipmentModel
    ? `${equipmentModel}${equipment?.model?.year ? ` (${equipment.model.year})` : ''}`
    : '--'
  const technicalOpinion = forwarding?.directive_entry?.diagnostic?.technical_response ?? forwarding?.directive_entry?.technical_response

  return (
    <div className="flex flex-col gap-4">
      <ColumnHeader icon={Wrench} title="Processo de manutenção" />

      <Section title="Informações">
        <div className="flex flex-wrap gap-x-8 gap-y-3">
          <ResumeItem className="text-xs" valueClassName="font-bold text-sm" label="Processo de manutenção" value={forwarding?.workflow?.protocol_number || '--'} />
          <ResumeItem className="text-xs" valueClassName="font-bold text-sm" label="Tipo de encaminhamento" value={directiveEntryType ? maintenanceForwardingEntryTypeLabel(directiveEntryType) : '--'} />
          <ResumeItem className="text-xs" valueClassName="font-bold text-sm" label="Criada em" value={formatDateTime(new Date(proposal.created_at))} />
          <ResumeItem className="text-xs" valueClassName="font-bold text-sm" label={equipmentFieldLabel} value={equipment?.field_for_display_value || '--'} />
        </div>

        <ResumeItem className="text-xs" valueClassName="font-bold text-sm" label="Modelo do equipamento" value={equipmentModelLabel} />
      </Section>

      <Box className="p-4 flex flex-col gap-4">
        <div className="flex flex-col gap-3">
          <p className="text-sm font-medium">Parecer técnico do diagnóstico</p>
          <TextBlock value={technicalOpinion} emptyLabel="Nenhum parecer técnico informado." />
        </div>

        <div className="border-t border-white-200" />

        <div className="flex flex-col gap-3">
          <p className="text-sm font-medium">Observações do processo</p>
          <TextBlock value={forwarding?.workflow?.observations} emptyLabel="Nenhuma observação informada." />
        </div>

        <div className="border-t border-white-200" />

        <ProposalSolicitations workflowId={forwarding?.workflow?.id} />
      </Box>

      {directiveConfig?.DiagnosticSection && <directiveConfig.DiagnosticSection proposal={proposal} />}
    </div>
  )
}

export default ProposalProcessColumn
